import { Component, OnDestroy, OnInit } from '@angular/core';
import { TextComponent } from '../../shared/components/text/text.component';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatToolbar } from '@angular/material/toolbar';
import { FormDetailComponent } from './form-detail/form-detail.component';
import { FormsService } from './forms.service';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { HomeRouterDialogComponent } from '../../shared/components/dialogs/home-router-dialog/home-router-dialog';
import { SharedStorage } from '../../shared/interfaces/share-storage.model';
import { Forms, QuestionAnswerList } from './forms';
import { FormControl, FormArray, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { TagComponent } from '../../shared/components/tag/tag.component';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CammeraStatusService } from '../../shared/services/cammera-status.service';
import { filter } from 'rxjs/operators';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Location } from '@angular/common'; // 確保導入的是這個路徑
import { DuoActionDialogComponent } from '../../shared/components/dialogs/duo-action-dialog/duo-action-dialog.component';
export interface QuestionItem {
  sortNo: number;
  questionId: number;
  questionName: string;
  description: string;
  questionType: string;
  choiceList: Array<{
    sortNo: number;
    choiceId: string;
    choiceName: string;
    description: string;
    choiceValue: string;
  }>;
}
// 定義每一組的結構
export interface QuestionGroupConfig {
  title: string;
  indices: number[];
}
type MyReservationType = SharedStorage['myReservation'];
type CreateMemberRequestType = SharedStorage['createMemberRequest'];
@Component({
  selector: 'app-forms',
  imports: [TextComponent, MatProgressBar, MatToolbar, ReactiveFormsModule, FormDetailComponent, TagComponent,],
  templateUrl: './forms.component.html',
  styleUrl: './forms.component.scss'
})
export class FormsComponent implements OnInit, OnDestroy {
  constructor(public FormsService: FormsService, private router: Router,
    private route: ActivatedRoute, private sharedStorageService: SharedStorageService,
    private dialog: MatDialog, private sanitizer: DomSanitizer, private toastrService: ToastrService, private cammeraStatusService: CammeraStatusService,
    private translateService: TranslateService, private location: Location,) {
    this.myReservation = this.sharedStorageService.get('myReservation') || {};
    this.MemberRequest = this.sharedStorageService.get('createMemberRequest') || {};
    console.log(this.myReservation)
  }
  public questionPlaceholders: { [key: number]: string } = {};
  percentValue: number = 0;
  totalQuestions: number = 0;
  routerSub: any
  showFormDetail: boolean = false//健調表內頁顯示
  answerRequest: Partial<Forms> = {};
  // 目前所在的題組索引（從 0 開始）
  currentGroupIndex: number = 0;
  allQuestions: QuestionItem[] = [];
  // 拆分後的題組資料，提供給 form-detail 顯示
  groupedQuestions: QuestionItem[][] = [];
  questionnaireName: string = ''
  groupedHealthQuestions: QuestionItem[][] = [];
  healthGroupedMap: QuestionItem[][][] = [];
  public questionErrorMessages: { [key: number]: { [key: string]: string } } = {};
  currentAnswerGroups: FormGroup[] = [];
  myReservation: Partial<MyReservationType> = {}
  MemberRequest: Partial<CreateMemberRequestType> = {}
  questionnaireTypeId: string = '';
  currentSubGroupIndex: number = 0;
  private specialPainData: { choiceId: string; answer: string; questionId: number }[] = [];
  form = new FormGroup({
    answers: new FormArray<FormGroup>([]),
  });
  private questionIndexMap = new Map<number, number>();
  // 可自行調整每組題數，若有剩餘題目會自動放到最後一組
  //此區為工作異常負荷表分類
  groupIndexes: number[][] = [[0, 1]];   // 第 0、1 題一組
  //此區為骨骼表分類
  private type2Indexes: number[][] = [[0, 1, 2, 3, 4, 5], [6, 7, 8, 9, 10, 11, 12], [13], [14], [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29], [30]];
  // 此區為健調表分類
  healthCheckIndex: number[][] = [
    [0, 1, 2, 3, 4, 5, 6, 11, 12],
    [7, 8, 9, 10],
    [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38],
    [39, 40, 41, 42, 43, 44],
    [45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62]
  ];
  //健康背景拆題
  healthCheckSecondIndex = [
    [0, 1],          // 第 1 頁 (自覺症狀等)
    [2, 3, 4, 5, 6],    // 第 2 頁 (過往病史等)
    [7, 8],          // 第 3 頁 (修正：原本 [7, 9] 會跳題且超出範圍)       // 第 4 頁 (修正：原本 [8, 10] 會重複且超出範圍)
  ];
  //服用藥物與手術史拆題 
  healthCheckSecondIndex2 = [
    [0, 1],          // 第 1 頁 (自覺症狀等)
    [2, 3],    // 第 2 頁 (過往病史等)
  ];
  //生活習慣拆題 
  healthCheckSecondIndex3 = [
    [0, 1, 2, 3, 4],
    [5, 6, 7, 8, 9],
    [10, 11, 12, 13, 14, 15],
    [16],
    [17],
    [21],
  ]
  //其他資訊拆題 
  healthCheckSecondIndex4 = [
    [0, 1],
    [2],
    [3],
    [4, 5],
  ]
  //其他資訊拆題 
  healthCheckSecondIndex5 = [
    [2, 3, 4, 5],
    [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
  ]
  //定義一個陣列來記錄各組狀態，假設有 6 組卡片
  groupCompletionStatus: boolean[] = [false, false, false, false, false];
  //制定健調表(生活習慣)規則
  branchRules = {
    triggerIndex: 17, // 對應 healthCheckSecondIndex3 中的索引位置
    options: {
      '1643': [22, 23, 24, 25], // 假設 answer 等於 1 的 choiceId 是 1643
      '1644': [18, 19, 20]      // 假設 answer 等於 2 的 choiceId 是 1644
    }
  };
  consentFormData: {
    name?: string; chartNo?: string; address?: string; cell?: string;
  } = {};
  needConsentType: string[] = ['5', '6', '7', '8']
  // 此區為健調表分類
  get businessCardIndex(): number {
    if (this.questionnaireTypeId === '3') return this.currentGroupIndex;
    if (this.questionnaireTypeId === '1') return 0; // 假設類型 1 固定跑健康規則
    return -1;
  }
  ngOnInit(): void {
    //將骨骼表傳回主表
    this.FormsService.painData$.subscribe(data => {
      this.specialPainData = data.map(group => ({
        choiceId: group.choiceId,
        answer: group.answer,
        questionId: group.questionId
      }));
    });
    //取得表單題目
    this.initializeBasicData()

    //偵測是否回到上一頁
    this.TriggerPopState()
  }

  TriggerPopState() {
    this.routerSub = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // 只偵測瀏覽器歷史導航（返回或前進）
        if (event.navigationTrigger === 'popstate') {

          const reserveType = this.sharedStorageService.get('reserveType');
          if (reserveType) {
            // 如果是預約流程才會跳彈窗
            // 立即導航回當前 URL，取消 popstate 導航（替換歷史記錄，避免頁面切換）
            const currentUrl = this.router.url;  // 取得當前 URL (包含 query params)

            // 解析 URL 和 query parameters
            const urlTree = this.router.parseUrl(currentUrl);
            const path = urlTree.root.children['primary']?.segments.map(s => s.path).join('/') || '';
            const queryParams = urlTree.queryParams;

            // 使用正確的格式導航，保留 query parameters
            this.router.navigate(['/' + path], {
              queryParams: queryParams,
              replaceUrl: true
            });

            // 偵測到返回
            console.log("偵測到返回");

            const resetConfirmDialog = this.dialog.open(HomeRouterDialogComponent, {
              data: {
                title: '還沒填完，確定要離開?',
                message: '這次填寫的內容暫時無法保留，下次進來需要重新填寫',
                status: 'alert',
                submitAction: true,
                buttonText: '繼續填寫',
                buttonText2: '稍後填寫',
                closeAction: () => {
                  resetConfirmDialog.close();

                },
                action: () => {
                  resetConfirmDialog.close();
                  this.router.navigate(['/healthcheck/member/mybooking']).then();
                  return
                },
              },
            });
          }

        }
      }
    });
  }
  // 回到首頁
  navigateToHome(): void {
    if (this.sharedStorageService.get('healthPlan') === 'special') {
      this.sharedStorageService.clear();
      this.router.navigate(['/healthcheck/healthplan']).then();
    } else {
      this.sharedStorageService.clear();
      this.router.navigate(['/healthcheck/member/mybooking']).then();
    }
  }

  //動態轉換健調表是否有運動題目
  private buildDynamicHealthCheckSecondIndex3ByAnswer(group: QuestionItem[]): QuestionItem[][] {
    if (!group.length) return [];
    // 固定頁
    const baseIndexes: number[][] = [
      [0, 1, 2, 3, 4],
      [5, 6, 7, 8, 9],
      [10, 11, 12, 13, 14, 15],
      [16],
      [17],
      [21],
    ];
    const result: QuestionItem[][] = baseIndexes
      .map(indexGroup =>
        indexGroup
          .filter(index => index >= 0 && index < group.length)
          .map(index => group[index])
      )
      .filter(page => page.length > 0);

    // 找 trigger 題
    const triggerQuestion = group[this.branchRules.triggerIndex];
    if (!triggerQuestion) {
      return result;
    }

    const answerIndex = this.questionIndexMap.get(triggerQuestion.questionId);
    const triggerAnswerGroup =
      answerIndex !== undefined ? this.answersArray.at(answerIndex) : null;

    if (!triggerAnswerGroup) {
      return result;
    }

    const selectedChoiceId = triggerAnswerGroup.get('choiceId')?.value;

    const optionAChoiceId = '1643';
    const optionBChoiceId = '1644';

    const branchAIndexes = this.branchRules.options[optionAChoiceId] ?? [];
    const branchBIndexes = this.branchRules.options[optionBChoiceId] ?? [];

    const branchAQuestions = branchAIndexes
      .filter(index => index >= 0 && index < group.length)
      .map(index => group[index]);

    const branchBQuestions = branchBIndexes
      .filter(index => index >= 0 && index < group.length)
      .map(index => group[index]);

    let branchQuestions: QuestionItem[] = [];

    if (selectedChoiceId === optionAChoiceId) {
      branchQuestions = branchBQuestions;
    } else if (selectedChoiceId === optionBChoiceId) {
      branchQuestions = branchAQuestions;
    }

    // ✅ 一頁一題
    const branchPages: QuestionItem[][] = branchQuestions.map(q => [q]);

    if (branchPages.length) {
      result.splice(5, 0, ...branchPages);
    }

    return result;
  }

  /**
 * 初始化基本資料與訂閱
 */
  private initializeBasicData(): void {
    // 1. 初始化基礎參數
    this.questionnaireTypeId = this.route.snapshot.paramMap.get('questionnaireTypeId') ?? ''

    // 2. 準備同意書資料 (封裝邏輯，減少主流程干擾)
    this.prepareConsentFormData();

    // 3. 執行問卷獲取與初始化
    this.fetchAndSetupQuestionnaire();
  }

  /**
   * 準備同意書資料
   */
  private prepareConsentFormData(): void {
    this.consentFormData = {
      name: this.MemberRequest?.name,
      chartNo: this.MemberRequest?.chartNo,
      address: this.myReservation?.consentFormData?.address,
      cell: this.MemberRequest?.cell,
    };
  }

  /**
   * 封裝同意書需要資料
   */
  async fetchConsentAndRedirect(): Promise<void> {
    // 呼叫 formatSubmitData 取得目前封裝好的資料
    // 此時 questionList 會根據目前的表單狀態產生 (初始值)
    const initialData = this.formatSubmitData();
    this.FormsService.getConsentsData(initialData).subscribe({
      next: async (res) => {
        //有鏡頭權限
        if (this.needConsentType.includes(this.questionnaireTypeId)) {
          await this.cammeraStatusService.triggerCameraApproval();
        }
        if (res.success && res.data.signUrl && this.cammeraStatusService.hasCamera() === true) {
          // 成功取得連結，直接導向電簽頁面
          try {
            console.log('即將跳轉到電簽頁面:', res.data.signUrl);
            window.location.href = res.data.signUrl;
          } catch (e) {
            alert("您的瀏覽器阻擋了自動跳轉，請檢查設定或手動開啟連結。");
          }
        }
        //沒有鏡頭權限 
        else if (res.success && res.data.qrCode && this.cammeraStatusService.hasCamera() === false) {
          const dialogRef = this.dialog.open(HomeRouterDialogComponent, {
            disableClose: false,
            data: {
              submitAction: true,
              title: '請掃描 QR Code 簽署同意書',
              status: 'alert',
              message: '您的裝置未偵測到鏡頭，請以手機掃描下方 QR Code 進行簽署。',
              qrCodeStatus: true,
              buttonText: '關閉視窗',
              qrCodeImg: res.data.qrCode, // 傳遞 Base64 字串
              closeAction: () => {
                dialogRef.close();
                this.router.navigate(['/healthcheck/member/mybooking']).then();
              },
              action: () => {
                dialogRef.close();
                this.router.navigate(['/healthcheck/member/mybooking']).then();
              },
            }
          });
          // ⭐️ 監聽子元件發出的 refresh 需求
          dialogRef.componentInstance.refreshQrCode.subscribe(() => {
            console.log('收到子元件發出的重新整理請求，準備呼叫 API...');

            // 呼叫你的 API 服務
            this.FormsService.getConsentsData(initialData).subscribe({
              next: (res) => {
                // 假設後端回傳新圖片欄位為 res.newQrCodeImg
                const newImg = res.data.qrCode;

                // ⭐️ 呼叫子元件的方法，把新圖片塞回去並重置 5 分鐘計時
                dialogRef.componentInstance.updateAndReset(newImg);
              },
              error: (err) => {
                console.error('重新取得 QR Code 失敗', err);
              }
            });
          });
        }
        else {
          console.warn('未取得簽署連結:', res.message);
        }
      },
      error: (err) => {
        console.error('取得電簽資料失敗', err);
      }
    });

  }
  /**
   * 獲取問卷數據並驅動後續初始化
   */
  private fetchAndSetupQuestionnaire(): void {
    const requestPayload = {
      caseNo: this.myReservation?.caseNo,
      idNo: this.MemberRequest?.idNo,
      questionnaireTypeId: this.questionnaireTypeId
    };

    this.FormsService.getQuestionnaireData(requestPayload).subscribe(res => {
      const sourceData = res?.data;
      if (!sourceData) return;

      // 1. 優先設定基礎 Request 資料 (fetchConsentAndRedirect 會用到)
      this.questionnaireName = sourceData.questionnaireName;
      this.setupAnswerRequest(sourceData);

      // 2. 🔥 關鍵判斷：如果是電簽類型，立即處理並中斷
      if (this.needConsentType.includes(this.questionnaireTypeId) && this.questionnaireTypeId !== '5') {
        this.FormsService.setLoading(true);// 顯示 Loading 遮罩，不讓使用者看到後面的題目
        //加入監聽螢幕鏡頭判斷
        this.fetchConsentAndRedirect();
        return; // 🛑 這裡直接 return，下面的 buildAnswerForm 等邏輯完全不會跑
      } else {
        // --- 以下是一般問卷流程 (非電簽類型才會執行) ---
        const list: QuestionItem[] = sourceData.questionList ?? [];
        this.allQuestions = list;
        this.totalQuestions = list.length;

        let answerMap = new Map<number, any>();
        const currentStatus = this.getCurrentQuestionnaireStatus();
        if ((currentStatus === '3' || currentStatus === '4') && sourceData.answerList || (this.questionnaireTypeId === '5' && sourceData.answerList)) {
          answerMap = this.convertAnswerListToMap(sourceData.answerList);
        }
        this.buildAnswerForm(list, answerMap);
        this.processQuestionGrouping(list);

        if (this.questionnaireTypeId === '3') {
          this.checkInitialCompletionStatus(answerMap);
        }
        this.currentGroupIndex = 0;
        this.syncCurrentAnswerGroups();
        this.updateProgressByGroup();
      }

    });
  }
  /**
   * 針對類型 3 的拆題，初始化每一組的完成狀態
   * @param answerMap 已經從 API 轉換好的 Map<questionId, answer>
   * // 0: 開始填寫 (完全沒資料), 1: 填寫中, 2: 已完成 (全部有資料)
   */
  checkInitialCompletionStatus(answerMap?: Map<number, any>, forceCompleteGroupIdx?: number): void {
    // 取得總組數
    const totalGroups = this.healthCheckIndex.length;
    this.groupCompletionStatus = this.healthCheckIndex.map((indices, groupIdx) => {
      // 🔥 增強點 1：如果是 submit 當下指定要強制完成的組別，直接給 true
      if (forceCompleteGroupIdx !== undefined && groupIdx === forceCompleteGroupIdx) {
        return true;
      }
      // 🔥 增強點 2：如果沒有 answerMap（例如在 submit 時純更新狀態），且不屬於 forceComplete，
      // 就維持它原本陣列裡記錄的狀態，不重複計算
      if (!answerMap) {
        return this.groupCompletionStatus[groupIdx] ?? false;
      }
      // --- 以下為你原本的 API 初始化計算邏輯 ---
      // 找出這組中沒填寫的題目
      const missingRequiredQuestions = indices.filter(idx => {
        const question = this.allQuestions[idx];
        if (!question) return false;
        const answer = answerMap.get(question.questionId);
        const hasValue = (
          answer !== undefined &&
          answer !== null &&
          answer !== '' &&
          (!Array.isArray(answer) || answer.length > 0)
        );
        return !hasValue;
      });
      // 計算已填寫題數
      const answeredCount = indices.length - missingRequiredQuestions.length;
      // 判斷各組完成標準
      if (groupIdx === totalGroups - 1) {
        // 最後一組：需要填寫超過 2 題
        return answeredCount > 2;
      } else {
        // 其他組：只要有填寫（超過 0 題）
        return answeredCount > 0;
      }
    });
  }
  private getCurrentQuestionnaireStatus(): string {
    // 預設給 1 (假設找不到視為新填寫)
    let status = '1';
    const statusList = this.myReservation?.consentFormData?.questionnaireStatusList;
    if (statusList && Array.isArray(statusList)) {
      // 使用 find 找尋匹配的 ID，比 forEach 效能更好且代碼簡潔
      const target = statusList.find(item => item.questionnaireTypeId === this.questionnaireTypeId);
      if (target) {
        status = target.status;
      }
    }

    return status;
  }

  /**
   * 設置提交用的請求物件
   */
  private setupAnswerRequest(sourceData: any): void {
    const referrerUrl = this.sharedStorageService.get('currentRoute') || '';
    // const previousUrl =referrerUrl ? referrerUrl.pathname : '/healthcheck/member/mybooking';
    Object.assign(this.answerRequest, {
      companyNo: sourceData.companyNo ?? '1150',
      customerId: this.MemberRequest?.idNo ?? '',
      caseNo: this.myReservation?.caseNo ?? '',
      docId: this.needConsentType.includes(this.questionnaireTypeId) ? '5' : '',
      formId: sourceData.formId,
      formStatus: '', // 2：已完成健調表電子填寫 4：已填寫、未完成
      callbackUrl: referrerUrl ?? '/healthcheck/member/mybooking',
      questionnaireTypeId: this.questionnaireTypeId,
      questionnaireId: sourceData.questionnaireId,
      isMobile: this.cammeraStatusService.hasCamera() === true ? false : true,
      entQuestionnaireId: sourceData.entQuestionnaireId,
      ...(this.needConsentType.includes(this.questionnaireTypeId) ? { consentFormData: this.consentFormData } : {})
    });
  }

  /**
   * 處理核心的分組邏輯
   */
  private processQuestionGrouping(list: QuestionItem[]): void {
    const type = this.questionnaireTypeId;

    // 類型 3：健檢問卷（最複雜，雙層分組）
    if (type === '3') {
      const healthGroups = this.splitByIndexes(list, this.healthCheckIndex);
      this.healthGroupedMap = healthGroups.map((group, idx) => {
        const config: Record<number, any[]> = {
          0: this.healthCheckSecondIndex,
          1: this.healthCheckSecondIndex2,
          3: this.healthCheckSecondIndex4,
          4: this.healthCheckSecondIndex5
        };

        if (idx === 2) {
          return this.buildDynamicHealthCheckSecondIndex3ByAnswer(group);
        }

        return this.splitHealthGroupsByIndexes([group], config[idx] || this.healthCheckSecondIndex);
      });
      this.groupedQuestions = healthGroups; // 外部容器參考大組
    }
    // 類型 2：特定索引映射
    else if (type === '2') {
      this.groupedQuestions = this.type2Indexes.map(idxGroup =>
        idxGroup.map(i => this.allQuestions[i]).filter(q => !!q)
      );
    }
    // 類型 1 與 其他
    else {
      const splitIdx = (type === '1') ? this.groupIndexes : [];
      this.groupedQuestions = this.splitByIndexes(list, splitIdx);
    }

    console.log(`問卷類型 ${type} 分組完成:`, this.groupedQuestions);
  }

  /**
   * 將取得的答案陣列轉為 Map 以利快速存取
   */
  private convertAnswerListToMap(answerList: any[]): Map<number, any> {
    const map = new Map<number, any>();
    answerList.forEach(ans => map.set(ans.questionId, ans));
    return map;
  }

  //整理健康檢查表單
  buildHealthCareForm1(list: QuestionItem[][]): void {
    console.log('所有題目:', list);

    // 進一步拆分每個組（例如根據 questionType）
    this.groupedQuestions = list.flatMap(group => {
      const inputQuestions = group.filter(q => q.questionType === '1');      // 輸入題
      const radioQuestions = group.filter(q => q.questionType === '3');      // 單選題
      const checkboxQuestions = group.filter(q => q.questionType === '4');   // 複選題

      // 返回拆分後的組，只保留有題目的組
      return [inputQuestions, radioQuestions, checkboxQuestions].filter(g => g.length > 0);
    });

    console.log('進一步拆分後:', this.groupedQuestions);
  }
  private splitHealthGroupsByIndexes(
    groups: QuestionItem[][],
    healthCheckSecondIndex: number[][] = []
  ): QuestionItem[][] {

    const flatList = groups.flat();

    if (!flatList.length) {
      return [];
    }

    // ❗ 如果沒有第二層索引 → 直接回空（或你也可以 return groups）
    if (!healthCheckSecondIndex.length) {
      return [];
    }

    const result: QuestionItem[][] = [];

    for (const indexGroup of healthCheckSecondIndex) {
      const validGroup = indexGroup
        .filter(index => index >= 0 && index < flatList.length)
        .sort((a, b) => a - b);

      if (!validGroup.length) continue;

      result.push(validGroup.map(index => flatList[index]));
    }

    return result;
  }
  get answersArray(): FormArray<FormGroup> {
    return this.form.get('answers') as FormArray<FormGroup>;
  }
  leavePage(): void {
    if (this.questionnaireTypeId !== '3') {
      const dialogRef = this.dialog.open(HomeRouterDialogComponent, {
        disableClose: false,
        data: {
          title: '還沒填完，確定要離開?',
          message: '這次填寫的內容暫時無法保留，下次進來需要重新填寫',
          status: 'alert',
          submitAction: true,
          buttonText2: '稍後填寫',
          buttonText: '繼續填寫',
          closeAction: () => {
            dialogRef.close();
            return
          },
          action: () => {
            dialogRef.close();
            this.router.navigate(['/healthcheck/member/mybooking']).then();
          },
        }
      })
    } else {
      if (this.showFormDetail) {
        const dialogRef = this.dialog.open(HomeRouterDialogComponent, {
          disableClose: false,
          data: {
            title: '還沒填完，確定要離開?',
            message: '這次填寫的內容暫時無法保留，下次進來需要重新填寫',
            status: 'alert',
            submitAction: true,
            buttonText: '繼續填寫',
            buttonText2: '稍後填寫',
            closeAction: () => {
              dialogRef.close();
              return
            },
            action: () => {
              dialogRef.close();
              this.showFormDetail = !this.showFormDetail
              return
            },
          },
        })

        return
      }
      //企業問卷
      this.checkInitialCompletionStatus(undefined, this.currentGroupIndex);
      let statusToCheck = [];
      if (this.myReservation.dataType === '2') {
        // 企業：全選 (0-4)
        statusToCheck = this.groupCompletionStatus;
      } else {
        // 個人：只拿前 4 個 (index 0, 1, 2, 3)
        statusToCheck = this.groupCompletionStatus.slice(0, 4);
      }

      // 2. 執行檢查 (注意箭頭函式省略大括號，或是補上 return)
      const allComplete = statusToCheck.every(status => status === true);
      this.FormsService.setHealthCheckStatus(allComplete); // 將狀態傳回 Service，讓其他頁面也能知道填寫狀況
      // 3. 觸發 Alert/Toastr
      if (allComplete) {
        this.router.navigate(['/healthcheck/member/mybooking']).then();
      } else {
        const dialogRef = this.dialog.open(HomeRouterDialogComponent, {
          disableClose: false,
          data: {
            title: '還沒填完，確定要離開?',
            message: '這次填寫的內容暫時無法保留，下次進來需要重新填寫',
            status: 'alert',
            submitAction: true,
            buttonText: '繼續填寫',
            buttonText2: '稍後填寫',
            closeAction: () => {
              dialogRef.close();

            },
            action: () => {
              dialogRef.close();
              this.router.navigate(['/healthcheck/member/mybooking']).then();
              return
            },
          },
        })
      }
    }

  }

  // 根據指定的每組題數切分題目列表
  private splitByIndexes(list: QuestionItem[], groupedIndexes: number[][] = []): QuestionItem[][] {
    if (!list.length) {
      return [];
    }
    if (!groupedIndexes.length) {
      return list.map(item => [item]);
    }
    const groupedIndexMap = new Map<number, number[]>();
    for (const group of groupedIndexes) {
      const validGroup = group
        .filter(index => index >= 0 && index < list.length)
        .sort((a, b) => a - b);

      if (!validGroup.length) {
        continue;
      }
      for (const index of validGroup) {
        groupedIndexMap.set(index, validGroup);
      }
    }
    const result: QuestionItem[][] = [];
    const visited = new Set<number>();
    for (let index = 0; index < list.length; index++) {
      if (visited.has(index)) {
        continue;
      }
      const group = groupedIndexMap.get(index);
      if (group?.length) {
        result.push(group.map(itemIndex => list[itemIndex]));
        group.forEach(itemIndex => visited.add(itemIndex));
        continue;
      }
      result.push([list[index]]);
      visited.add(index);
    }
    return result;
  }
  //進一步拆分健康檢查表的題組
  healthFormSpiltByIndexes(list: QuestionItem[], healthCheckIndex: number[][] = []): QuestionItem[][] {
    if (!list.length) {
      return [];
    }
    if (!healthCheckIndex.length) {
      return list.map(item => [item]);
    }
    const groupedIndexMap = new Map<number, number[]>();
    for (const group of healthCheckIndex) {
      const validGroup = group
        .filter(index => index >= 0 && index < list.length)
        .sort((a, b) => a - b);

      if (!validGroup.length) {
        continue;
      }
      for (const index of validGroup) {
        groupedIndexMap.set(index, validGroup);
      }
    }
    const result: QuestionItem[][] = [];
    const visited = new Set<number>();
    for (let index = 0; index < list.length; index++) {
      if (visited.has(index)) {
        continue;
      }
      const group = groupedIndexMap.get(index);
      if (group?.length) {
        result.push(group.map(itemIndex => list[itemIndex]));
        group.forEach(itemIndex => visited.add(itemIndex));
        continue;
      }
      result.push([list[index]]);
      visited.add(index);
    }
    return result;
  }


  /**
 * 建立問卷表單結構
 * @param list 題目列表
 * @param answerMap 歷史答案 Map (選填)
 */
  private buildAnswerForm(list: any[], answerMap: Map<number, any>): void {
    this.answersArray.clear();
    this.questionIndexMap.clear();

    list.forEach((q, index) => {
      // A. 取得該題在 answerList 中的數據
      const savedData = answerMap.get(q.questionId);
      let initialAnswer: any = q.questionType === '4' ? [] : '';
      let initialChoiceId = '';

      // B. 如果有保存的答案，解析並賦值
      if (savedData && savedData.questionAnswerList?.length > 0) {
        if (q.questionType === '4') {
          // 多選題：收集所有 choiceId 變成陣列
          initialAnswer = savedData.questionAnswerList.map((a: any) => a.choiceId);
        }
        else if (q.questionType === '3') {
          // 🔥 Radio 專用修正：因為 HTML 綁定 [value]="c.sortNo"
          // 我們要從答案中找到對應的 sortNo 填入 answer 欄位
          initialChoiceId = savedData.questionAnswerList[0].choiceId || '';

          // 從題目原始的選項清單中，用 choiceId 換回 sortNo
          const targetChoice = q.choiceList.find((c: any) => c.choiceId === initialChoiceId);
          initialAnswer = targetChoice ? targetChoice.sortNo : '';
        } else {
          // 單選、填空、日期：取得第一筆資料
          // answer 存放文字內容，choiceId 存放選中的 ID
          initialAnswer = savedData.questionAnswerList[0].answer || '';
          initialChoiceId = savedData.questionAnswerList[0].choiceId || '';
        }
      } else if (q.questionName.includes('姓名')) {
        // 沒答案但為姓名欄位，自動帶入
        initialAnswer = this.MemberRequest?.name || '';
      }

      // C. 建立 Control（帶入解析後的 initialAnswer）
      const validators = this.getValidatorsByQuestion(q); // 建議將驗證邏輯抽成小函式
      const answerControl = new FormControl(initialAnswer, validators);

      const answerGroup = new FormGroup({
        questionId: new FormControl(q.questionId),
        questionType: new FormControl(q.questionType),
        answer: answerControl,
        choiceId: new FormControl(initialChoiceId),
        untilNow: new FormControl(false),
      });

      // D. 處理欄位狀態 (如果是 status 3 且你希望唯讀，可以在此 disable)
      if (q.questionName.includes('姓名')) {
        answerGroup.get('answer')?.disable();
      }

      this.answersArray.push(answerGroup);
      this.questionIndexMap.set(q.questionId, index);
    });
  }

  /**
 * 根據題目類型與問卷類型決定驗證規則
 */
  private getValidatorsByQuestion(q: any): any[] {
    const config = this.FormsService.getRegisteredValidators(q.questionId);
    if (config) {
      this.questionErrorMessages[q.questionId] = config.errorMessages;
      this.questionPlaceholders[q.questionId] = config.placeholder || '請輸入';
      return config.validators;
    }
    let validators: any[] = [];

    // 👉 健康問卷（Type 3）的邏輯
    if (this.questionnaireTypeId === '3') {
      if (q.questionType === '4') {
        validators.push(this.requiredArrayValidator); // 自定義的多選必填
      } else {
        validators.push(Validators.required);
      }
      return validators;
    }

    // 👉 一般問卷（Type 1, 2, 其他）的邏輯
    // 🔹 Radio (3) 一律必填
    if (q.questionType === '3') {
      validators.push(Validators.required);
    }

    // 🔹 Input (1) 或 填空 (9)
    else if (q.questionType === '1' || q.questionType === '9') {
      // 檢查選項描述中是否包含「必填」或「如無」
      const isRequiredText = q.choiceList?.some((c: any) => {
        const desc = c.description || '';
        return desc.includes('必填') || desc.includes('如無');
      });
      const isNameField = q.questionName.includes('姓名');
      // 如果文字包含必填且不是姓名欄位，或者是特定的 Consent 類型
      if ((isRequiredText && !isNameField) || this.needConsentType.includes(this.questionnaireTypeId)) {
        validators.push(Validators.required);
      }
    }
    return validators;
  }

  requiredArrayValidator(control: any) {
    const value = control.value;
    if (Array.isArray(value) && value.length === 0) {
      return { required: true };
    }
    return null;
  }
  // 同步目前題組的 FormGroup 陣列，提供給 form-detail 顯示
  private syncCurrentAnswerGroups(): void {
    let currentQuestions: QuestionItem[] = [];

    if (this.questionnaireTypeId === '3') {
      // 取得當前大組中的特定子頁面
      const subGroups = this.healthGroupedMap[this.currentGroupIndex] || [];
      currentQuestions = subGroups[this.currentSubGroupIndex] || [];
    } else {
      currentQuestions = this.groupedQuestions[this.currentGroupIndex] || [];
    }
    if (this.questionnaireTypeId === '2') {
      if (this.currentGroupIndex === 0) {
        // 圖片頁：清空題目，這會讓子組件不跑迴圈，只顯圖
        currentQuestions = [];
      } else {
        // 🔥 關鍵修正：currentGroupIndex 是 1, 2, 3... 
        // 我們要抓 type2Indexes[0, 1, 2...]，所以要減 1
        const groupRule = this.type2Indexes[this.currentGroupIndex - 1];

        if (groupRule) {
          currentQuestions = groupRule
            .map(idx => this.allQuestions[idx])
            .filter(q => !!q); // 過濾掉可能的 undefined
        }
      }
    }
    this.currentAnswerGroups = currentQuestions
      .map(q => {
        const answerIndex = this.questionIndexMap.get(q.questionId);
        return answerIndex !== undefined ? this.answersArray.at(answerIndex) : null;
      })
      .filter((group): group is FormGroup => group !== null);
    console.log(this.currentAnswerGroups)
  }
  // 根據目前所在的題組計算整體完成度百分比
  private updateProgressByGroup(): void {
    if (!this.groupedQuestions.length || this.totalQuestions === 0) {
      this.percentValue = 0;
      return;
    }

    // 進度以「已走到的組」累計題數計算
    const completedCount = this.groupedQuestions
      .slice(0, this.currentGroupIndex + 1)
      .reduce((sum, group) => sum + group.length, 0);

    this.percentValue = Math.round((completedCount / this.totalQuestions) * 100);
  }

  private nextQuestion(): void {
    const currentAnswers = this.currentAnswerGroups.map(group => group.getRawValue());
    // 🔥 新增判斷：檢查是否有觸發「提前結束」的題目
    const triggerEnd = currentAnswers.find(ans =>
      ans.questionId === 29 && ans.choiceId === '83'
    );
    if (this.questionnaireTypeId === '3') {
      // ... 原有的 Type 3 邏輯保持不變 ...
      const subGroups = this.healthGroupedMap[this.currentGroupIndex] || [];
      if (this.currentSubGroupIndex < subGroups.length - 1) {
        this.currentSubGroupIndex++;
      } else {
        this.showFormDetail = false;
        this.currentSubGroupIndex = 0;
        return;
      }
      console.log('123213123', this.currentSubGroupIndex)
      if (this.currentGroupIndex === 2 && this.currentSubGroupIndex === 5) {
        this.rebuildHealthCard3Pages();
      }

    } else if (this.questionnaireTypeId === '2') {
      // 🔥 Type 2 專屬邏輯
      // 因為圖片佔了第 0 頁，所以總步數是題目組長度 + 1
      const totalSteps = this.groupedQuestions.length + 1;
      if (triggerEnd) {
        console.log('使用者選擇「否」，直接提交表單');
        this.submitQuestions(); // 直接呼叫提交邏輯
        return
      }
      console.log(this.currentGroupIndex)
      const hasPain = this.specialPainData.some(item => item.answer !== '0');

      if (!hasPain && this.currentGroupIndex == 5) {
        const dialogRef = this.dialog.open(HomeRouterDialogComponent, {
          disableClose: true,
          data: {
            title: '請選擇您疼痛的部位填答',
            message: '請選擇過去一年曾持續痠痛、不適或影響關節活動之情況的部位，並填入疼痛程度。',
            status: 'alert',
            buttonText: '我知道了',
            submitAction: true,
            closeAction: () => {
              dialogRef.close();
              return
            },
            action: () => {
              dialogRef.close();
              return
            },
          },
        });
      } else {
        if (this.currentGroupIndex < totalSteps - 1) {
          this.currentGroupIndex++;
        } else {
          return;
        }
      }

    } else {
      // 一般 Type 1 邏輯
      if (this.currentGroupIndex < this.groupedQuestions.length - 1) {
        this.currentGroupIndex++;
      } else {
        return;
      }
    }

    // 執行同步與更新
    this.syncCurrentAnswerGroups();
    this.updateProgressByGroup();
  }
  private rebuildHealthCard3Pages(): void {
    const healthGroups = this.splitByIndexes(this.allQuestions, this.healthCheckIndex);
    const group = healthGroups[2];
    if (!group) return;

    this.healthGroupedMap[2] = this.buildDynamicHealthCheckSecondIndex3ByAnswer(group);
  }
  private prevQuestion(): void {
    if (this.questionnaireTypeId === '3') {
      // 【健康調查表】的特殊邏輯
      if (this.currentSubGroupIndex > 0) {
        // 在同一個大組內切換子頁面
        this.currentSubGroupIndex--;
      } else {
        // 在子頁面第一頁按上一步，回到大列表
        this.showFormDetail = false;
        this.currentSubGroupIndex = 0;
        return; // 這裡結束，不需要執行下面的 sync
      }
    } else {
      // 【一般問卷】(Type 1, 2) 的邏輯
      if (this.currentGroupIndex > 0) {
        this.currentGroupIndex--;
      } else {
        // 如果已經是第一組，可以選擇回到列表或不做事
        this.showFormDetail = false;
        return;
      }
    }

    // 統一執行同步與進度更新
    this.syncCurrentAnswerGroups();
    this.updateProgressByGroup(); // 確保進度條也會跟著退回
  }

  //顯示該卡牌的form-detail
  selectGroup(index: number): void {
    this.currentGroupIndex = index;
    this.currentSubGroupIndex = 0; // 重置子分頁索引

    this.syncCurrentAnswerGroups(); // 使用統一的同步邏輯
    this.showFormDetail = true;
  }


  async submitQuestions(): Promise<void> {
    this.FormsService.setLoading(true);
    if (this.needConsentType.includes(this.questionnaireTypeId)) {
      this.FormsService.getConsentsData(this.formatSubmitData()).subscribe({
        next: async (res) => {
          this.FormsService.setLoading(false)
          //有鏡頭權限
          if (this.needConsentType.includes(this.questionnaireTypeId)) {
            await this.cammeraStatusService.triggerCameraApproval();
          }
          if (res.success && res.data.signUrl && this.cammeraStatusService.hasCamera() === true) {
            try {
              console.log('即將跳轉到電簽頁面:', res.data.signUrl);
              window.location.href = res.data.signUrl;
            } catch (e) {
              alert("您的瀏覽器阻擋了自動跳轉，請檢查設定或手動開啟連結。");
            }
          }
          //沒有鏡頭權限 
          else if (res.success && res.data.qrCode && this.cammeraStatusService.hasCamera() === false) {
            const dialogRef = this.dialog.open(HomeRouterDialogComponent, {
              disableClose: false,
              data: {
                submitAction: true,
                title: '請掃描 QR Code 簽署同意書',
                status: 'alert',
                message: '您的裝置未偵測到鏡頭，請以手機掃描下方 QR Code 進行簽署。',
                qrCodeStatus: true,
                buttonText: '關閉視窗',
                qrCodeImg: res.data.qrCode, // 傳遞 Base64 字串
                closeAction: () => {
                  dialogRef.close();
                  this.router.navigate(['/healthcheck/member/mybooking']).then()
                },
                action: () => {
                  dialogRef.close();
                  this.router.navigate(['/healthcheck/member/mybooking']).then()
                },
              }
            });
            // ⭐️ 監聽子元件發出的 refresh 需求
            dialogRef.componentInstance.refreshQrCode.subscribe(() => {
              console.log('收到子元件發出的重新整理請求，準備呼叫 API...');

              // 呼叫你的 API 服務
              this.FormsService.getConsentsData(this.formatSubmitData()).subscribe({
                next: (res) => {
                  // 假設後端回傳新圖片欄位為 res.newQrCodeImg
                  const newImg = res.data.qrCode;

                  // ⭐️ 呼叫子元件的方法，把新圖片塞回去並重置 5 分鐘計時
                  dialogRef.componentInstance.updateAndReset(newImg);
                },
                error: (err) => {
                  console.error('重新取得 QR Code 失敗', err);
                }
              });
            });

          }
        }
      })
    } else {
      this.checkInitialCompletionStatus(undefined, this.currentGroupIndex);
      let statusToCheck = [];
      if (this.myReservation.dataType === '2') {
        // 企業：全選 (0-4)
        statusToCheck = this.groupCompletionStatus;
      } else {
        // 個人：只拿前 4 個 (index 0, 1, 2, 3)
        statusToCheck = this.groupCompletionStatus.slice(0, 4);
      }

      // 2. 執行檢查 (注意箭頭函式省略大括號，或是補上 return)
      const allComplete = statusToCheck.every(status => status === true);
      if (allComplete) {
        this.answerRequest.formStatus = '2';
      } else {
        this.answerRequest.formStatus = '4'; // 如果沒過是否要改回 4，視你的需求而定
      }
      this.FormsService.insertAnswerData(this.formatSubmitData()).subscribe({
        next: (res) => {
          this.FormsService.setLoading(false);
          if (res.success) {
            if (this.questionnaireTypeId !== '3') {
              const dialogRef = this.dialog.open(HomeRouterDialogComponent, {
                disableClose: true,
                data: {
                  title: '問卷已送出',
                  showCloseButton: false,
                  status: 'true',
                  message: '填好問卷，當天報到更順暢',
                  buttonText: '返回本次預約',
                  submitAction: true,
                  action: () => {
                    dialogRef.close();
                    if (this.questionnaireTypeId !== '3') {
                      this.router.navigate(['healthcheck/member/mybooking']).then();
                    } else {
                      this.showFormDetail = false
                    }
                  },
                  closeAction: () => {
                    dialogRef.close();
                    this.router.navigate(['/healthcheck/member/mybooking']).then();
                  },
                },
              });
            } else {
              this.toastrService.success('已填寫完畢!')
              this.showFormDetail = false
            }

          } else {

            const dialogRef = this.dialog.open(HomeRouterDialogComponent, {
              disableClose: true,
              data: {
                title: '暫時無法送出',
                status: 'false',
                message: '請稍後再試一次',
                buttonText: '再試一次',
                buttonText2: '繼續填寫下一份',
                submitAction: true,
                closeAction: () => {
                  dialogRef.close();
                  this.router.navigate(['/healthcheck/member/mybooking']).then();
                },
                action: () => {
                  dialogRef.close();
                  this.router.navigate(['/healthcheck/member/mybooking']).then();
                },
              },
            });
          }
        }
      })
    }

  }


  // 處理 form-detail 發出的導航事件
  async onNavigationChange(event: { direction: 'prev' | 'next' | 'submit' }, index?: number): Promise<void> {
    if (event.direction === 'next') {
      this.nextQuestion();
    } else if (event.direction === 'prev') {
      this.prevQuestion();
    } else if (event.direction === 'submit') {
      // 這裡可以處理提交表單的邏輯，例如將 this.form.getRawValue() 發送到後端
      await this.submitQuestions();
      if (this.questionnaireTypeId === '3' && index !== undefined) {
        this.groupCompletionStatus[index] = true;
      }
    }
  }

  //整理送出數據格式
  private formatSubmitData(): any {
    // 1. 將 disabled 欄位補 choiceId (保持原邏輯)
    this.answersArray.controls.forEach(group => {
      if (group.get('answer')?.disabled) {
        const questionId = group.get('questionId')?.value;
        const question = this.allQuestions.find(q => q.questionId === questionId);
        if (question && question.choiceList.length > 0) {
          group.get('choiceId')?.setValue(question.choiceList[0].choiceId);
        }
      }
    });
    const rawValue = this.form.getRawValue();
    const answerMap = new Map<number, any>(
      rawValue.answers.map((item: any) => [item.questionId, item])
    );
    const questionList: QuestionAnswerList[] = this.allQuestions
      .map(question => {
        const answerItem = answerMap.get(question.questionId);
        const hasSpecialData = this.specialPainData.length > 0 &&
          this.specialPainData.some(item => item.questionId === question.questionId);

        if (!answerItem) return null;

        // 特殊組件處理 (保持原邏輯)
        if (hasSpecialData) {
          return {
            sortNo: String(question.sortNo),
            questionId: question.questionId,
            questionAnswerList: this.specialPainData
              .filter(item => item.questionId === question.questionId)
              .map(item => ({
                choiceId: item.choiceId,
                answer: item.answer,
              }))
          };
        }
        // 🔥 檢查是否為空值 (字串為空、null、或空陣列)
        const isAnswerEmpty =
          answerItem.answer === '' ||
          answerItem.answer === null ||
          (Array.isArray(answerItem.answer) && answerItem.answer.length === 0);
        // 🔥 新邏輯：如果是類型 3 且沒填寫，直接回傳 null，讓這題從 questionList 中消失
        if ((this.questionnaireTypeId === '3' || this.questionnaireTypeId === '2') && isAnswerEmpty) {
          return null;
        }
        let questionAnswerList: { choiceId: string; answer: string }[] = [];
        // Checkbox 題型處理
        if (question.questionType === '4') {
          const selectedAnswers = Array.isArray(answerItem.answer) ? answerItem.answer : [];
          questionAnswerList = selectedAnswers.map((choiceId: string) => {
            const choice = question.choiceList.find(c => c.choiceId === choiceId);
            return {
              choiceId,
              answer: choice ? String(choice.sortNo) : '',
            };
          });
        }
        // 其他一般題型
        else {
          questionAnswerList = [
            {
              choiceId: answerItem.choiceId ?? '',
              answer: answerItem.answer ?? '',
            },
          ];
        }
        return {
          sortNo: String(question.sortNo),
          questionId: question.questionId,
          questionAnswerList,
        };
      })
      // 🔥 最後這行 filter 會把所有回傳 null 的題目（沒填寫的類型 3）剔除
      .filter((item): item is QuestionAnswerList => item !== null);
    return {
      ...this.answerRequest,
      questionList,
    };
  }


  // 假設這是你的對照表函式，加入 totalPage 欄位
  mapHealthCheckIndexToContainerName(index: number) {
    const meta = [
      { title: '健康背景', detail: '個人病史、家族病史、近期身體狀況', totalPage: 3 },
      { title: '服用藥物與手術史', detail: '長期服用藥物、手術史與重大外傷', totalPage: 2 },
      { title: '生活習慣', detail: '飲食習慣、運動習慣', totalPage: 10 },
      { title: '其他資訊', detail: '長住國家、婚姻、教育程度、職位', totalPage: 5 },
      { title: '作業經歷', detail: '曾經與目前工作狀態', totalPage: 5 }
    ];
    return meta[index] || { title: '未定義', detail: '', totalPage: 0 };
  }
  ngOnDestroy(): void {
    // 取消訂閱返回的偵測以避免記憶體洩漏
    if (this.routerSub) {
      this.routerSub.unsubscribe();
      console.log("取消訂閱返回");
    }
  }

}
